import { useState } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SmartSendProcessing } from '../SmartSendProcessing';
import SmartSendItemDisplay from './SmartSendItemDisplay';
import SmartSendInViewCheck from './SmartSendInViewCheck';
import { P2GBox } from '@parcel2go/core-ui';
import Loading from '../../../../../components/loading/Loading';

export interface SmartSendItemProps {
  item: SmartSendItemApiModel;
  isXs: boolean;
}

export default function SmartSendItem(props: SmartSendItemProps) {
  const [inView, setInview] = useState(false);

  if (!props.item.State) {
    return null;
  }

  if (!inView) {
    return (
      <SmartSendInViewCheck timeout={350} inview={setInview} triggerOnce={false}>
        <P2GBox p={4} textAlign="center">
          <Loading />
        </P2GBox>
      </SmartSendInViewCheck>
    );
  }

  return (
    <SmartSendProcessing
      processing={!['IDLE', 'ERROR'].includes(props.item.State.state)}
      className="p2g-smartsend-item"
    >
      {props.item && <SmartSendItemDisplay item={props.item} isXs={props.isXs} />}
    </SmartSendProcessing>
  );
}
